import type { KkmHandshakeReady, KkmHandshakeResult } from '@/shared/api';

import { type OrderPaymentMethod, OrderPaymentMethod as PaymentMethod } from '@shared/api/graphql/gql/graphql';

type AcquiringTerminal = KkmHandshakeReady['terminals'][number];

/**
 * Единое правило выбора эквайрингового терминала: готовый в приоритете, иначе
 * первый из списка. Им же собирается снимок оборудования для `prepare`.
 */
export function selectAcquiringTerminal(handshake: KkmHandshakeReady): AcquiringTerminal | undefined {
  return handshake.terminals.find((snapshot) => snapshot.status === 'ready') ?? handshake.terminals[0];
}

/**
 * Серверный список — политика; состояние оборудования знает только браузер
 * кассы. Пока живого источника нет (моста нет, KKMServer не ответил, ошибка
 * протокола), политика возвращается как есть: без источника ухудшать
 * доступность нельзя, отказ остаётся за гейтом `prepare`.
 */
export function liveAllowedMethods(
  serverMethods: readonly OrderPaymentMethod[],
  handshake: KkmHandshakeResult | null,
): readonly OrderPaymentMethod[] {
  if (handshake === null || handshake.kind !== 'ready') {
    return serverMethods;
  }

  // Готовый handshake — и есть подтверждение готовности ККТ: тем же фактом
  // собирается `kkt.status = READY` в снимке для `prepare`.
  return selectAcquiringTerminal(handshake)?.status === 'ready'
    ? serverMethods
    : serverMethods.filter((method) => method !== PaymentMethod.Card);
}
